import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { Loader } from '@applyft-web/ui-components';
import { useGoogleAuth, useGoogleFontPreload } from '../../core/hooks';
import { darkPalette, isDarkTheme } from '../../core/theme';
import * as S from './styled';

interface GoogleSignInButtonProps {
  screenId?: string;
}

export const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({ screenId = '' }) => {
  useGoogleFontPreload();
  const { t } = useTranslation();
  const { isBtnPreloaded, handleCustomButtonClick } = useGoogleAuth(screenId);
  const theme = useTheme();
  const loaderBg = isDarkTheme(theme) ? darkPalette.background : '#ffffff';

  return (
    <>
      {!isBtnPreloaded && <Loader customStyles={`background-color: ${loaderBg}`} />}
      <S.GoogleButtonWrapper>
        <S.GoogleButtonContainer id="googleSignInButton" />
        <S.CustomGoogleButton onClick={handleCustomButtonClick}>
          <S.GoogleLogo src="/images/google_btn.svg" alt="Google" />
          {t('continue_with_google')}
        </S.CustomGoogleButton>
      </S.GoogleButtonWrapper>
      <S.Separator>
        <span>{t('or')}</span>
      </S.Separator>
    </>
  );
};
